import axios from 'axios'

export default {
    getDashboard: (filters) => axios.get('admin/reports/send-times/dashboard', { params: filters }),
    getSummary: (filters) => axios.get('admin/reports/send-times/summary', { params: filters }),
    getHeatmap: (filters) => axios.get('admin/reports/send-times/heatmap', { params: filters }),
    getBestSlots: (filters) => axios.get('admin/reports/send-times/best-slots', { params: filters }),
    getByHour: (filters) => axios.get('admin/reports/send-times/by-hour', { params: filters }),
    getByWeekday: (filters) => axios.get('admin/reports/send-times/by-weekday', { params: filters }),
    getByMessageType: (filters) => axios.get('admin/reports/send-times/by-message-type', { params: filters }),
    getScheduledVsManual: (filters) => axios.get('admin/reports/send-times/scheduled-vs-manual', { params: filters }),
    getDataQuality: (filters) => axios.get('admin/reports/send-times/data-quality', { params: filters }),
}
